import { EVENT_WARNING_TYPES } from './EventWarningTypes';

export const EVENT_REAPPRAISAL_RATIONALE_STATUS_MAP = new Map([
  [EVENT_WARNING_TYPES.REAPPRAISAL_RATIONALE_PENDING_SUBMISSION, 'Pending Submission'],
  [EVENT_WARNING_TYPES.REAPPRAISAL_RATIONALE_RETURNED_BY_FDA, 'Pending Revision'],
  [EVENT_WARNING_TYPES.REAPPRAISAL_RATIONALE_PENDING_FDA_APPROVAL, 'Pending Approval'],
  [EVENT_WARNING_TYPES.REAPPRAISAL_RATIONALE_APPROVED, 'Approved']
]);
